import { render, staticRenderFns } from "./ServiceOrdersOpenedByDay.vue?vue&type=template&id=2295999d"
import script from "./ServiceOrdersOpenedByDay.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersOpenedByDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports